import { render, staticRenderFns } from "./WorkOrderView.vue?vue&type=template&id=0d3857b8&scoped=true&"
import script from "./WorkOrderView.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderView.vue?vue&type=script&lang=ts&"
import style0 from "./WorkOrderView.vue?vue&type=style&index=0&id=0d3857b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3857b8",
  null
  
)

export default component.exports